export default {
  actions: 'actions',
  expandActionsControl: 'Expand all actions'
};
